export default __webpack_public_path__ + "static/media/logo-us-pottery.dadc3726.svg";